function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons/Custom/Roommates");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Custom/Roommates",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.859731,26.3430806 L18.204862,27.5308682 C15.4007142,29.5435503 11.7129288,29.8388903 8.62420127,28.2981448 C4.29800187,26.1401131 3.35627395,22.0869857 3.0196036,19.6852482 C2.79515671,18.0840899 4.49802429,15.3907847 8.12820635,11.6053325 C12.4404358,10.6843057 15.3398324,10.8143009 16.8263961,11.9953182 C17.6007928,12.6105463 18.6357192,13.4075918 19.672363,14.2628162 C20.3430358,13.4465568 21.1364765,12.5607289 22.0526848,11.6053325 C26.3649142,10.6843057 29.2643108,10.8143009 30.7508746,11.9953182 C32.9807202,13.7668441 37.3706965,17.0458726 37.7417901,18.8805985 C38.2386154,21.3369559 37.2488221,23.8563575 35.2128693,25.3176662 L32.1293405,27.5308682 C29.3251927,29.5435503 25.6374073,29.8388903 22.5486797,28.2981448 C21.4488435,27.7495152 20.5677501,27.0784029 19.859731,26.3430806 Z M19.859731,26.3430806 L21.2883857,25.317659 C23.3243436,23.8563575 24.314137,21.3369559 23.8173116,18.8805985 C23.5750941,17.6830492 21.6206954,15.8701778 19.672363,14.2628162 C17.6857095,16.680723 16.7762825,18.4882004 16.9440821,19.6852482 C17.1951618,21.4763995 17.7827609,24.1860167 19.859731,26.3430806 Z",
  id: "Roommates-icon",
  stroke: "#EFCEA3",
  strokeWidth: 2,
  fill: "#FCF6E3"
}));

var SvgDoubleBullet = function SvgDoubleBullet(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoubleBullet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/double-bullet.fecf97ff.svg";
export { ForwardRef as ReactComponent };